<template>
<div class="chapter">
<div class="inner_page">
<p class="dedit"><a id="page_8"></a>In Memory of</p>
<p class="dedi">Flight Sergeant Eric W. Spriggs, R.A.F. 1921-1944</p>
<p class="dedi">Navigator of a Lancaster, 15 Squadron Bomber Command</p>
<p class="dedi">Killed on active service, June 21, 1944.</p>
<a id="page_9"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedi.vue?051b7ef1